import { Card } from '@components/primitives/Card.js'
import { EXPORT_RELATORIOS } from './constants.js'

export function ExportRelatoriosSection() {
  return (
    <Card surface='raised'>
      <div className='cf3-config-section'>
        <p className='cf3-config-section__title'>Exportar Relatórios</p>
        <p className='cf3-config-section__desc'>
          Abre uma visualização pronta para imprimir ou salvar como PDF.
        </p>
        <div className='cf3-config-export-list'>
          {EXPORT_RELATORIOS.map((r) => (
            <button
              key={r.titulo}
              type='button'
              className='cf3-config-export-item'
              onClick={() => void r.fn()}
            >
              <div className='cf3-config-export-item__body'>
                <div className='cf3-config-export-item__title'>{r.titulo}</div>
                <div className='cf3-config-export-item__desc'>{r.desc}</div>
              </div>
              <span className='cf3-config-export-item__chevron' aria-hidden>
                ›
              </span>
            </button>
          ))}
        </div>
      </div>
    </Card>
  )
}
